import { render, staticRenderFns } from "./PaymentThankYouPagePayingBill.vue?vue&type=template&id=5189bf25&"
import script from "./PaymentThankYouPagePayingBill.vue?vue&type=script&lang=js&"
export * from "./PaymentThankYouPagePayingBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports